// The clock (docs/ARCHITECTURE.md §2.3): one 30 s tick for everything that prints "in 26 min". The map doesn't
// redraw on it unless a pin's look is due to change (MapController lookChangeAt).
import { createStore, useStore } from "zustand";

export const clockStore = createStore<{ now: Date }>()(() => ({ now: new Date() }));
export const useNow = () => useStore(clockStore, (s) => s.now);
export const now = () => clockStore.getState().now;
export const tick = () => clockStore.setState({ now: new Date() });

let timer: ReturnType<typeof setInterval> | null = null;
export function startClock() {
  if (timer) return;
  timer = setInterval(tick, 30e3);
}
